import * as _ from 'lodash';

const pickUser = data =>
  _.omit(data, ['confirmPassword','password','referralCode','email']);

export default pickUser;
